const INITIAL_STATE = {
  data: {},
  errors: {},
    
}
const ForgotPassword = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'FORGOT_PASSWORD_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'FORGOT_PASSWORD_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
    
export default ForgotPassword;